export const HOME_NAV_KEY = 'home_nav_state'
export const HOME_TAB_RETURN_KEY = 'home_tab_return'

const SNAPSHOT_FN_KEY = '__homeSnapshotFn'

/**
 * 功能：读取外层首页滚动容器。
 * 参数：无。
 */
export function getIndexBodyEl() {
  if (typeof document === 'undefined') {
    return null
  }
  return document.querySelector('.index-page .index-body') || document.querySelector('.index-body')
}

/**
 * 功能：判断是否为首页根路由。
 * 参数：path 当前路由 path。
 */
export function isHomeRoute(path) {
  return path === '/'
}

/**
 * 功能：读取首页导航缓存。
 * 参数：无。
 */
export function readHomeNavCache() {
  try {
    const raw = sessionStorage.getItem(HOME_NAV_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

/**
 * 功能：写入首页导航缓存。
 * 参数：data 首页快照数据。
 */
export function writeHomeNavCache(data) {
  try {
    sessionStorage.setItem(HOME_NAV_KEY, JSON.stringify(data))
  } catch (e) {
    // ignore quota errors
  }
}

/**
 * 功能：标记下次进入首页需要按底部 Tab 返回恢复。
 * 参数：无。
 */
export function markHomeTabReturn() {
  try {
    sessionStorage.setItem(HOME_TAB_RETURN_KEY, '1')
  } catch (e) {
    // ignore
  }
}

/**
 * 功能：判断当前是否需要恢复首页滚动和快照。
 * 参数：无。
 */
export function shouldRestoreHomeOnEnter() {
  try {
    return sessionStorage.getItem(HOME_TAB_RETURN_KEY) === '1'
  } catch (e) {
    return false
  }
}

/**
 * 功能：清除首页恢复意图标记。
 * 参数：无。
 */
export function clearHomeRestoreIntent() {
  try {
    sessionStorage.removeItem(HOME_TAB_RETURN_KEY)
  } catch (e) {
    // ignore
  }
}

/**
 * 功能：注册首页快照函数，供底部 Tab 切走前调用。
 * 参数：fn 生成首页快照的函数。
 */
export function registerHomeSnapshot(fn) {
  if (typeof window === 'undefined') {
    return
  }
  window[SNAPSHOT_FN_KEY] = fn
}

/**
 * 功能：取消首页快照函数注册。
 * 参数：无。
 */
export function unregisterHomeSnapshot() {
  if (typeof window === 'undefined') {
    return
  }
  delete window[SNAPSHOT_FN_KEY]
}

/**
 * 功能：执行已注册的首页快照函数。
 * 参数：无。
 */
function takeHomeSnapshot() {
  if (typeof window === 'undefined') {
    return null
  }
  const fn = window[SNAPSHOT_FN_KEY]
  return typeof fn === 'function' ? fn() : null
}

/**
 * 功能：底部 Tab 离开首页前保存首页快照和滚动位置。
 * 参数：无。
 */
export function prepareHomeTabLeave() {
  markHomeTabReturn()
  const el = getIndexBodyEl()
  const scrollTop = el ? el.scrollTop : 0
  const snap = takeHomeSnapshot()
  writeHomeNavCache({
    ...(snap || readHomeNavCache() || {}),
    scrollTop: scrollTop > 0 ? scrollTop : Number((snap || {}).scrollTop || 0)
  })
}
